import { REMINDER_TEMPLATE_STATUS } from '@src/shared/types/reminder-template';

import type { badgeVariants } from '@src/design-system/badge';
import type { ValueOf } from '@src/shared/types/utilities';
import type { VariantProps } from 'class-variance-authority';

const REMINDER_TEMPLATE_STATUS_BADGE_VARIANTS: Record<
  ValueOf<typeof REMINDER_TEMPLATE_STATUS>,
  VariantProps<typeof badgeVariants>['variant']
> = {
  [REMINDER_TEMPLATE_STATUS.approved]: 'success',
  [REMINDER_TEMPLATE_STATUS.pending]: 'warning',
  [REMINDER_TEMPLATE_STATUS.saved]: 'default',
  [REMINDER_TEMPLATE_STATUS.rejected]: 'danger',
  [REMINDER_TEMPLATE_STATUS.recieved]: 'primaryBlue',
};

export const getStatusBadgeVariant = (
  status: ValueOf<typeof REMINDER_TEMPLATE_STATUS>
) => {
  return REMINDER_TEMPLATE_STATUS_BADGE_VARIANTS[status];
};

/** Templates table: approved / pending use fixed brand colors. */
export const getTemplateStatusBadgeClassName = (
  status: ValueOf<typeof REMINDER_TEMPLATE_STATUS>
) => {
  switch (status) {
    case REMINDER_TEMPLATE_STATUS.approved:
      return 'border-none bg-[#E6F6F4] text-[#03A78E]';
    case REMINDER_TEMPLATE_STATUS.pending:
      return 'border-none bg-secondary-100 text-secondary-1000';
    default:
      return undefined;
  }
};
